export default __webpack_public_path__ + "static/media/INEX-POLYGON.96526cd8.png";